import { ExperienceLevel } from "./types"

export function getDriverExperience(joinedAt: string) {
  const joinedDate = new Date(joinedAt)
  const now = new Date()

  // Calculate exact time difference
  const diffTime = Math.abs(now.getTime() - joinedDate.getTime())

  // Calculate months (using average month length of 30.44 days)
  const monthsActive = Math.floor(diffTime / (1000 * 60 * 60 * 24 * 30.44))

  // Calculate years (using exact 365 days)
  const years = Math.max(1, Math.floor(diffTime / (1000 * 60 * 60 * 24 * 365)))

  // Determine experience level
  let level: ExperienceLevel = "new"

  if (monthsActive >= 24) {
    level = "expert"
  } else if (monthsActive >= 6) {
    level = "intermediate"
  }

  return {
    years,
    monthsActive,
    level,
    joinYear: joinedDate.getUTCFullYear(),
    formattedDate: joinedDate.toLocaleDateString("en-US", {
      month: "long",
      year: "numeric",
      timeZone: "UTC",
    }),
  }
}

export function getDriverTenureLabel(joinedAt: string): string | null {
  if (Number.isNaN(new Date(joinedAt).getTime())) {
    return null
  }

  const { monthsActive, years } = getDriverExperience(joinedAt)

  if (monthsActive < 12) {
    return null
  }

  return `${years} Year${years === 1 ? "" : "s"}`
}

export function getDriverTenureSentence(joinedAt: string): string {
  const tenureLabel = getDriverTenureLabel(joinedAt)

  if (!tenureLabel) {
    return "Independent transporter on CitizenShipper."
  }

  return `Independent transporter on CitizenShipper for ${tenureLabel.toLowerCase()}.`
}
